import { 
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs
} from '@ionic/react';
import React, { useState, useEffect } from 'react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import MyTasks from './home/mytasks/MyTasks';
import Task from './home/mytasks/Task';
import Workflows from './home/workflows/Workflows';
import More from './home/more/More';
import Workflow from './home/workflows/Workflow';
import Dar from './home/dar/Dar';
import Ia from './home/ia/Ia';
import Con from './home/con/Con';
import Wp from './home/wp/Wp';
import Form from './home/workflows/Form';
import { Switch, withRouter } from "react-router";
import './Home.css';

import { ServerService } from "../services/Server"
import { modules } from "./settings/modules/SelectModule";
import Util from '../services/Util';
//import { useEffect } from 'react';
import DarForm from './home/dar/DarForm';
import IaForm from './home/ia/IaForm';
import ConForm from './home/con/ConForm';
import WpForm from './home/wp/WpForm';
import WpIns from './home/wp/WpInspection';
import WpQc from './home/wp/WpQc';
import WpDtl from './home/wp/WpDtl';
import WpIdCheck from './home/wp/WpIdCheck';
import WpWork from './home/wp/WpWork';
import DarHistory from './home/dar/DarHistory';
import Signature from './home/mytasks/Signature';
import Bams from './home/bams/Bams';
import BamsForm from './home/bams/BamsForm';
import CheckInOut from './home/bams/CheckInOut';
import WorkCalendar from './home/bams/WorkCalendar';
import JobDetail from './home/bams/JobDetail';
import Site from './home/site/Site';
import SiteForm from './home/site/SiteForm';

interface HomeMemberPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
  tab: string;
  pageId: number;
}

const modulePages = [{
  page:null,
  url:''
},{
  page:MyTasks,
  url:'/mytasks',
  children:[2,28]
},{
  page:Task,
  url:'/task/:id/:type/:dummy'
},{
  page:Workflows,
  url:'/workflows/:dummy',
  children:[4,5]
},{
  page:Workflow,
  url:'/workflow/:mid/:hid/:name'
},{
  page:Form,
  url:'/form/:id/:hid/:dummy'
},{
  page:More,
  url:'/more'
},{
  page:Dar,
  url:'/dar',
  children:[8,20]
},{
  page:DarForm,
  url:'/darForm/:id/:dummy'
},{
  page:Ia,
  url:'/ia',
  children:[10]
},{
  page:IaForm,
  url:'/form/:id/:dummy'
},{
  page:Con,
  url:'/con',
  children:[12]
},{
  page:ConForm,
  url:'/form/:id/:dummy'
},{
  page:Wp,
  url:'/wp',
  children:[14,15,16,17,18,19]
},{
  page:WpForm,
  url:'/wpForm/:id/:dummy'
},{
  page:WpIns,
  url:'/wpIns/:id/:dummy'
},{
  page:WpQc,
  url:'/wpQc/:id/:dummy'
},{
  page:WpDtl,
  url:'/wpDtl/:id/:dummy'
},{
  page:WpIdCheck,
  url:'/wpIdCheck/:id/:dummy'
},{
  page:WpWork,
  url:'/wpWork/:id/:dummy'
},{
  page:DarHistory,
  url:'/darHistory/:id/:dummy'
},{
  page:Bams,
  url:'/bams',
  children:[22,23,24,25]
},{
  page:BamsForm,
  url:'/bamsForm/:id/:dummy'
},{
  page:CheckInOut,
  url:'/checkInOut'
},{
  page:WorkCalendar,
  url:'/workCalendar'
},{
  page:JobDetail,
  url:'/jobDetail/:id/:dtlid'
},{
  page:Site,
  url:'/site',
  children:[27]
},{
  page:SiteForm,
  url:'/siteForm/:id/:dummy',
},{
  page:Signature,
  url:'/signature/:dummy'
}]

const Home: React.FC<RouteComponentProps> = ({match,history}) => {

//  console.log("Home Page : "+match.url);

  const routePages: HomeMemberPage[] = []
  const tabPages: HomeMemberPage[] = []

  var server = new ServerService();
  const moduleCfg = server.moduleCfg;

  server.setHistory(history);
  const util = new Util();

  var firstTab = "";

  //console.log("tabPageIdx:"+server.tabPageIdx)

  Object.keys(moduleCfg)?.forEach((pageIdx:any) => {
    const page = util.getKeyValue(pageIdx)(moduleCfg)
    page.forEach((mid: number) => {
      if (server.isAllowModule(mid)) {
        const module = modules[mid]

          if (pageIdx === server.tabPageIdx) {
            tabPages.push({
              title: module.title,
              url: "/"+module.tab,
              iosIcon: module.iosIcon,
              mdIcon: module.mdIcon,
              tab:module.tab,
              pageId:module.pageId
            })

      //      console.log("tab:"+module.tab);
            console.log("server.nextTab:"+server.nextTab);
            if (firstTab === "") {
              firstTab = server.nextTab
              if (!firstTab) {
                firstTab = module.tab;
              }
            }
            console.log("firstTab:"+firstTab);
          }

        if (module) {
          routePages.push({
            title: module.title,
            url: "/"+module.tab,
            iosIcon: module.iosIcon,
            mdIcon: module.mdIcon,
            tab:module.tab,
            pageId:module.pageId
          })
        }

        // if (module.pageId === 6) { // More Page
        //   const page = modulePages[module.pageId]
        //   page.children = []
        //   moduleCfg["1"].forEach(mrid => {
        //     const module = modules[mrid]
        //     if (module.pageId !== 0) {
        //       page.children.push(module.pageId)
        //     }
        //   })
        // }
      }
    })
  })

  // useEffect(()=>{
  //   server = new ServerService()
  // },[])

  return (
      <IonReactRouter>
      <IonTabs>
        <IonRouterOutlet>

          <Route key={match.url+"1"} path={match.url} exact={true}>
            <Redirect to={`${match.url}/${firstTab}`} />
            <>
            {console.log("match.url:"+match.url+" "+firstTab)}
            </>
          </Route>

          {routePages.map((memberPage, index) => {
            const page = modulePages[memberPage.pageId]
            
            var subPage = [
              <Route key={match.url+","+memberPage.tab+","+index} path={`${match.url}/:tab(`+memberPage.tab+')'} component={page.page} exact={true}/>
            ]
//            console.log("firstTab:"+(firstTab));
//            console.log("-----"+match.url+","+memberPage.tab+","+index)
            if (page.children) {
//              console.log("  children:"+memberPage.title);
              page.children.forEach(subPageId => {
                const child = modulePages[subPageId]
//                console.log("    child:"+child.url);
//                console.log("-----"+match.url+","+memberPage.tab+","+index+","+child.url)
                subPage.push(
                  <Route key={match.url+","+memberPage.tab+","+index+","+child.url} path={`${match.url}/:tab(`+memberPage.tab+')'+child.url} component={child.page}/>
                )
              })
            }

            return subPage
          })}

        </IonRouterOutlet>

        <Switch>
          <Route key={match.url+"2"} path={match.url} exact={true}>
            <Redirect to={`${match.url}/${firstTab}`} />
          </Route>
        </Switch>

        <IonTabBar slot="bottom" className="tab-bar" style={tabPages.length > 5 ? {"overflowX":"scroll","justifyContent":"left"} : {}}>
          {tabPages.map((tabPage, index) => {
            return (
              <IonTabButton key={index} tab={tabPage.tab} href={`${match.url}${tabPage.url}`}>
              <IonIcon ios={tabPage.iosIcon} md={tabPage.mdIcon} />
              <IonLabel className="large-label">{tabPage.title}</IonLabel>
              </IonTabButton>
            );
          })}
        </IonTabBar>
      </IonTabs>
      </IonReactRouter>
  );
}

export default withRouter(Home);
